<script lang="ts">

  const lastUpdated = '2026년 8월 17일'
  const serviceName = 'AX Hub'
  const contactEmail = 'support@1pass.dev'
</script>

  <div class="max-w-3xl mx-auto">
    <!-- Header -->
    <div class="mb-8">
      <div class="flex items-center gap-2 text-caption text-content-tertiary mb-4">
        <a href="/" class="hover:text-primary transition-colors">홈</a>
        <span>/</span>
        <span class="text-content">개인정보처리방침</span>
      </div>
      <h1 class="text-h1 text-content mb-2">개인정보처리방침</h1>
      <p class="text-body2 text-content-tertiary">최종 수정일: {lastUpdated}</p>
    </div>

    <div class="card card-bordered p-8 shadow-md space-y-8">

      <!-- 개요 -->
      <div class="p-4 bg-primary-50 dark:bg-primary/10 border border-primary/20 rounded-xl">
        <p class="text-body2 text-gray-700 dark:text-dark-text-medium leading-relaxed">
          {serviceName}(이하 "서비스")는 「개인정보보호법」을 준수하며, 이용자의 개인정보를 소중히 보호합니다.
          이 방침은 수집하는 개인정보의 항목, 수집 및 이용 목적, 보유 및 이용 기간에 관한 사항을 알려드립니다.
        </p>
      </div>

      <!-- 수집 항목 및 목적 -->
      <section>
        <h2 class="text-title text-content mb-4 pb-2 border-b border-default">
          제1조 (수집 항목 및 목적)
        </h2>
        <div class="overflow-hidden rounded-xl border border-default">
          <table class="w-full">
            <thead class="bg-surface-tertiary">
              <tr>
                <th class="px-4 py-3 text-left text-caption font-semibold text-content-tertiary">수집 항목</th>
                <th class="px-4 py-3 text-left text-caption font-semibold text-content-tertiary">수집 목적</th>
                <th class="px-4 py-3 text-left text-caption font-semibold text-content-tertiary">수집 방법</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100 dark:divide-dark-border text-caption text-gray-700 dark:text-dark-text-medium">
              <tr>
                <td class="px-4 py-3">이름, 이메일 주소</td>
                <td class="px-4 py-3">회원가입, 본인 확인</td>
                <td class="px-4 py-3">회원가입 시 직접 입력 또는 1pass 계정 연동 시 제공받음</td>
              </tr>
              <tr>
                <td class="px-4 py-3">직장 이메일 주소</td>
                <td class="px-4 py-3">소속 인증</td>
                <td class="px-4 py-3">인증 신청 시 직접 입력</td>
              </tr>
              <tr>
                <td class="px-4 py-3">프로필 이미지 (선택)</td>
                <td class="px-4 py-3">프로필 표시</td>
                <td class="px-4 py-3">프로필 설정 시 직접 등록</td>
              </tr>
              <tr>
                <td class="px-4 py-3">푸시 알림 토큰, 기기 플랫폼, 앱 버전</td>
                <td class="px-4 py-3">푸시 알림 발송</td>
                <td class="px-4 py-3">앱에서 알림 허용 시 자동 수집</td>
              </tr>
              <tr>
                <td class="px-4 py-3">접속 IP, 접속 로그</td>
                <td class="px-4 py-3">서비스 보안, 불법 행위 방지</td>
                <td class="px-4 py-3">서비스 이용 중 자동 수집</td>
              </tr>
              <tr>
                <td class="px-4 py-3">게시글, 댓글, 신고 내용</td>
                <td class="px-4 py-3">서비스 제공, 신고 처리</td>
                <td class="px-4 py-3">서비스 이용 중 직접 입력</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <!-- 보유 및 이용 기간 -->
      <section>
        <h2 class="text-title text-content mb-4 pb-2 border-b border-default">
          제2조 (보유 및 이용 기간)
        </h2>
        <div class="space-y-3 text-body2 text-gray-700 dark:text-dark-text-medium leading-relaxed">
          <p>
            ① 회원 탈퇴 시 계정과 작성한 게시글·댓글은 즉시 숨김 처리되어 다른 이용자에게 보이지 않으며,
            탈퇴일로부터 <strong>6개월</strong>이 지나면 영구 파기됩니다.
            숨김 기간은 오·남용 계정 조사와 법령상 분쟁 대응을 위한 것으로, 이 기간 중에도 서비스 화면에는 노출되지 않습니다.
            단, 관계 법령에 따라 일정 기간 보존이 필요한 경우 해당 법령에 따릅니다.
          </p>
          <p>② 전자상거래법에 따른 계약 또는 청약철회 관련 기록: 5년</p>
          <p>③ 접속 로그 기록: 3개월 (통신비밀보호법)</p>
          <p>④ 푸시 알림 토큰: 계정 파기 시 함께 삭제되며, 유효하지 않게 된 기기는 발송 대상에서 제외됩니다.</p>
        </div>
      </section>

      <!-- 신고 관련 개인정보 처리 -->
      <section>
        <h2 class="text-title text-content mb-4 pb-2 border-b border-default">
          제3조 (신고 관련 개인정보 처리)
        </h2>
        <div class="space-y-4">
          <div class="flex items-start gap-3 p-4 bg-surface-tertiary rounded-xl">
            <div class="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
              <svg class="w-4 h-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
              </svg>
            </div>
            <div>
              <p class="text-body2 font-semibold text-content mb-1">신고자 익명성 보장</p>
              <p class="text-caption text-content-secondary leading-relaxed">
                신고자의 이름, 이메일 등 개인정보는 피신고자(신고 대상자)에게 절대 공개되지 않습니다.
                신고 내용 처리에 필요한 최소한의 내부 관리 목적으로만 사용됩니다.
              </p>
            </div>
          </div>

          <div class="flex items-start gap-3 p-4 bg-surface-tertiary rounded-xl">
            <div class="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
              <svg class="w-4 h-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>
            <div>
              <p class="text-body2 font-semibold text-content mb-1">신고 내용 보관 기간</p>
              <p class="text-caption text-content-secondary leading-relaxed">
                처리 완료된 신고 내용은 처리 완료일로부터 <strong>1년간</strong> 보관 후 파기됩니다.
                단, 수사기관 협조 등 법적 의무가 있는 경우 해당 법령에 따른 기간 동안 보존됩니다.
              </p>
            </div>
          </div>

          <div class="flex items-start gap-3 p-4 bg-surface-tertiary rounded-xl">
            <div class="w-8 h-8 rounded-lg bg-error/10 flex items-center justify-center shrink-0">
              <svg class="w-4 h-4 text-error" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
              </svg>
            </div>
            <div>
              <p class="text-body2 font-semibold text-content mb-1">개인정보 침해 신고 처리 절차</p>
              <p class="text-caption text-content-secondary leading-relaxed">
                타인의 개인정보가 노출된 콘텐츠를 발견한 경우, 신고 사유에서 "개인정보 노출"을 선택하여 신고해 주세요.
                접수 후 <strong>72시간 이내</strong>에 처리됩니다 (개인정보보호법 준거).
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- 제3자 제공 -->
      <section>
        <h2 class="text-title text-content mb-4 pb-2 border-b border-default">
          제4조 (개인정보의 제3자 제공)
        </h2>
        <div class="space-y-3 text-body2 text-gray-700 dark:text-dark-text-medium leading-relaxed">
          <p>서비스는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다. 다만, 다음의 경우에는 예외로 합니다.</p>
          <ol class="list-decimal list-inside space-y-2 pl-2">
            <li>이용자가 사전에 동의한 경우</li>
            <li>법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차에 따라 수사기관의 요구가 있는 경우</li>
            <li>아동·청소년 성착취물(CSAM) 관련 신고를 수사기관에 통보하는 경우 (청소년성보호법 §17 의무)</li>
          </ol>
        </div>
      </section>

      <!-- 이용자 권리 -->
      <section>
        <h2 class="text-title text-content mb-4 pb-2 border-b border-default">
          제5조 (이용자의 권리)
        </h2>
        <div class="space-y-3 text-body2 text-gray-700 dark:text-dark-text-medium leading-relaxed">
          <p>이용자는 언제든지 다음의 권리를 행사할 수 있습니다.</p>
          <ol class="list-decimal list-inside space-y-2 pl-2">
            <li>개인정보 열람·정정·삭제 요청</li>
            <li>개인정보 처리 정지 요청</li>
            <li>회원 탈퇴 (탈퇴 즉시 숨김 처리, 6개월 경과 후 영구 파기 — 제2조 ① 참조)</li>
          </ol>
          <p>권리 행사는 설정 페이지 또는 아래 문의처를 통해 신청하실 수 있습니다.</p>
        </div>
      </section>

      <!-- 문의처 -->
      <section>
        <h2 class="text-title text-content mb-4 pb-2 border-b border-default">
          제6조 (개인정보보호 문의처)
        </h2>
        <div class="p-4 bg-surface-tertiary rounded-xl">
          <div class="space-y-2 text-body2 text-gray-700 dark:text-dark-text-medium">
            <p><strong>개인정보 보호 담당</strong>: {serviceName} 운영팀</p>
            <p><strong>이메일</strong>: <a href="mailto:{contactEmail}" class="text-primary hover:text-primary-dark">{contactEmail}</a></p>
            <p class="text-caption text-content-tertiary mt-3">
              개인정보 침해 관련 민원은 개인정보보호위원회(privacy.go.kr) 또는 한국인터넷진흥원(118)에 신고하실 수 있습니다.
            </p>
          </div>
        </div>
      </section>

      <!-- 부칙 -->
      <section>
        <h2 class="text-title text-content mb-4 pb-2 border-b border-default">
          부칙
        </h2>
        <div class="space-y-2 text-body2 text-gray-700 dark:text-dark-text-medium leading-relaxed">
          <p>이 방침은 {lastUpdated}부터 시행됩니다.</p>
          <p class="text-caption text-content-tertiary">
            2026년 8월 17일 개정: 수집 항목에 프로필 이미지·푸시 알림 토큰을 추가하고,
            탈퇴 시 파기 절차를 실제 처리 방식(즉시 숨김 후 6개월 경과 시 영구 파기)에 맞게 바로잡았습니다.
          </p>
          <p class="text-caption text-content-tertiary">종전 방침 시행일: 2026년 2월 20일</p>
        </div>
      </section>

    </div>

    <!-- 관련 링크 -->
    <div class="mt-6 flex items-center justify-center gap-4 text-body2">
      <a href="/terms" class="text-primary hover:text-primary-dark transition-colors">이용약관</a>
      <span class="text-gray-300 dark:text-dark-text-disabled">|</span>
      <a href="/" class="text-content-tertiary hover:text-primary transition-colors">홈으로</a>
    </div>
  </div>
